import {
    Box,
    Flex,
    Container,
    Text,
    Breadcrumb,
    BreadcrumbItem,
    useBreakpointValue,
    Heading,
    Image,
    Button,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";
import { Link as ReactLink } from "react-router-dom";

const AboutUs = () => {
    const bgPosition = useBreakpointValue({
        base: "center",
        md: "30% 55%",
    });

    return (
        <Box
            maxW="8xl"
            mx="auto"
            p={{ base: 0, lg: 12 }}
            minH="100vh"
        >
            <Flex
                borderRadius={{ base: 0, md: "12px" }}
                backgroundImage={`
                    linear-gradient(
                        90deg,
                        rgba(20, 20, 20, 0.55) 0%,
                        rgba(20, 20, 20, 0.20) 55%,
                        rgba(20, 20, 20, 0.05) 100%
                    ),
                    url('/images/rolunk/LTGy-11.jpg')
                `}
                backgroundSize="cover"
                backgroundPosition={bgPosition}
                minH={{ base: "220px", md: "340px" }}
                align="center"
                px={{ base: 6, md: 14 }}
                position="relative"
                overflow="hidden"
            >
                <Box zIndex={2}>
                    <Text
                    ms={{base:'0',md:'3'}}
                        fontFamily="'Playfair Display', serif"
                        fontSize={{ base: "3xl", md: "5xl", lg: "6xl" }}
                        lineHeight="1"
                        fontWeight="700"
                        color="white"
                        textShadow="0 3px 12px rgba(0,0,0,0.35)"
                    >
                        Rólunk
                    </Text>
                </Box>
                <Box
                    position="absolute"
                    zIndex={1}
                    top={{ base: '20px', md: '-30px' }}
                    left="0"
                    width={{ base: "150px", md: "350px" }}
                    height={{ base: "180px", md: "350px" }}
                    opacity={0.75}
                >
                    <svg
                        viewBox="0 0 200 200"
                        xmlns="http://www.w3.org/2000/svg"
                        width="100%"
                        height="100%"
                    >
                        <path
                            transform="translate(100 100)"
                            fill="#e63e3e"
                            d="
                                M35,-57
                                C48.4,-53,64.3,-49.7,74.9,-40.3
                                C85.4,-30.9,90.6,-15.4,90.7,0.1
                                C90.8,15.6,85.8,31.1,75.3,40.4
                                C64.7,49.7,48.4,52.8,35,60.9
                                C21.5,69,10.7,82.1,-1.7,85.1
                                C-14.2,88.1,-28.3,80.9,-39.5,71.4
                                C-50.6,61.9,-58.7,50.2,-66.7,38
                                C-74.8,25.7,-82.9,12.8,-85.5,-1.5
                                C-88.1,-15.9,-85.3,-31.7,-76.7,-43.2
                                C-68.2,-54.6,-53.9,-61.7,-40.2,-65.5
                                C-26.5,-69.3,-13.2,-70,-1.2,-67.9
                                C10.8,-65.8,21.7,-61,35,-57Z
                            "
                        />
                    </svg>
                </Box>
            </Flex>
            <Breadcrumb
                ms={{ base: 4, lg: 2 }}
                mt={4}
                fontFamily="Poppins, sans-serif"
                fontSize={{ base: "xs", md: "sm" }}
                spacing={{ base: "3px", md: "8px" }}
                separator={<ChevronRightIcon color="gray.400" />}
            >
                <BreadcrumbItem>
                    <ReactLink to="/">
                        Főoldal
                    </ReactLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                    <ReactLink to="/rolunk">
                        Rólunk
                    </ReactLink>
                </BreadcrumbItem>
            </Breadcrumb>
            <Container
                fontFamily="Poppins, sans-serif"
                maxW="container.xl"
                py={{ base: 8, md: 14 }}
            >

                <Flex
                    direction={{ base: "column", md: "row" }}
                    gap={{ base: 8, md: 14 }}
                    align="flex-start"
                >
                    <Box
                        width={{ base: "100%", md: "52%" }}
                        px={{ base: 1, md: 4 }}
                    >
                        <Text
                            color="red.600"
                            fontSize="sm"
                            fontWeight="600"
                            letterSpacing="1.5px"
                            textTransform="uppercase"
                            mb={2}
                        >
                            Több mint 25 éve
                        </Text>
                        <Heading
                            fontFamily="'Playfair Display', serif"
                            fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
                            fontWeight="700"
                            lineHeight="1.2"
                            color="gray.800"
                            mb={6}
                        >
                            A hagyomány, amit továbbviszünk
                        </Heading>
                        <Text
                            fontSize={{ base: "md", md: "17px" }}
                            lineHeight={{ base: "1.8", md: "1.9" }}
                            color="gray.700"
                            textAlign="justify"
                            mb={{ base: 6, md: 8 }}
                        >
                            A Nyír-Aranytojás Kft. több mint 25 éve gyártja
                            Laskod községben a jól ismert Laskodi
                            Száraztésztákat. Családi vállalkozásként
                            indultunk, és azóta is ebben a formában
                            készítjük házias jellegű tésztáinkat.
                        </Text>
                        <Image
                            display={{ base: "block", md: "none" }}
                            src="/images/rolunk/LTGy-65.jpg"
                            alt="Laskodi Tészta"
                            width="100%"
                            maxW="380px"
                            height="420px"
                            objectFit="cover"
                            mx="auto"
                            mb={8}
                            border="10px solid white"
                            boxShadow="0 12px 30px rgba(0,0,0,0.15)"
                            borderRadius="4px"
                        />
                        <Heading
                            fontFamily="'Playfair Display', serif"
                            fontSize={{ base: "xl", md: "2xl" }}
                            fontWeight="700"
                            color="gray.800"
                            mb={4}
                            mt={{ base: 2, md: 4 }}
                        >
                            Minőség hazai alapanyagokból
                        </Heading>

                        <Text
                            fontSize={{ base: "md", md: "17px" }}
                            lineHeight={{ base: "1.8", md: "1.9" }}
                            color="gray.700"
                            textAlign="justify"
                            mb={{ base: 6, md: 8 }}
                        >
                            Kezdettől azt tartottuk a legfontosabbnak,
                            hogy megőrizzük azt a minőséget, amit hajdan
                            szüleink házilag készítettek. Kizárólag
                            hazai piacról beszerzett minőségi, friss
                            tyúktojást és BFF 55 réteslisztet használunk
                            a gyártás során.
                        </Text>
                        <Image
                            display={{ base: "block", md: "none" }}
                            src="/images/rolunk/LTGy-31.jpg"
                            alt="Laskodi Tészta gyártás"
                            width="100%"
                            maxW="380px"
                            height="420px"
                            objectFit="cover"
                            mx="auto"
                            mb={8}
                            border="10px solid white"
                            boxShadow="0 12px 30px rgba(0,0,0,0.15)"
                            borderRadius="4px"
                        />
                        <Heading
                            fontFamily="'Playfair Display', serif"
                            fontSize={{ base: "xl", md: "2xl" }}
                            fontWeight="700"
                            color="gray.800"
                            mb={4}
                        >
                            Gazdaságos és kiadós
                        </Heading>
                        <Text
                            fontSize={{ base: "md", md: "17px" }}
                            lineHeight={{ base: "1.8", md: "1.9" }}
                            color="gray.700"
                            textAlign="justify"
                            mb={6}
                        >
                            Tésztáink főzés során kiváló vízfelvevő
                            képességüknek köszönhetően jelentősen
                            növelik tömegüket. Ezt azért is tartjuk
                            fontosnak, mert vásárlóink számára nemcsak
                            a minőség, hanem az ár-érték arány
                            szempontjából is jelentős különbséget
                            jelenthet.
                        </Text>
                        <Image
                            display={{ base: "block", md: "none" }}
                            src="/images/rolunk/LTGy-42.jpg"
                            alt="Laskodi Tészta"
                            width="100%"
                            maxW="380px"
                            height="420px"
                            objectFit="cover"
                            mx="auto"
                            border="10px solid white"
                            boxShadow="0 12px 30px rgba(0,0,0,0.15)"
                            borderRadius="4px"
                        />

                    </Box>
                    <Box
                        width={{ base: "100%", md: "48%" }}
                        display={{ base: "none", md: "block" }}
                        position="relative"
                        minH="720px"
                    >

                        <Image
                            src="/images/rolunk/LTGy-31.jpg"
                            alt="Laskodi Tészta"
                            position="absolute"
                            top="20px"
                            left={{ md: "40px", lg: "80px" }}
                            width={{ md: "260px", lg: "300px" }}
                            height={{ md: "350px", lg: "400px" }}
                            objectFit="cover"
                            border="10px solid white"
                            boxShadow="0 15px 35px rgba(0,0,0,0.16)"
                            transform="rotate(3deg)"
                            transition="all 0.3s ease"
                            _hover={{
                                transform: "rotate(1deg) scale(1.02)",
                                zIndex: 5,
                            }}
                        />

                        <Image
                            src="/images/rolunk/LTGy-42.jpg"
                            alt="Laskodi Tészta"
                            position="absolute"
                            top={{ md: "220px", lg: "230px" }}
                            left={{ md: "0px", lg: "20px" }}
                            width={{ md: "260px", lg: "300px" }}
                            height={{ md: "350px", lg: "400px" }}
                            objectFit="cover"
                            border="10px solid white"
                            boxShadow="0 15px 35px rgba(0,0,0,0.16)"
                            transform="rotate(-6deg)"
                            transition="all 0.3s ease"
                            _hover={{
                                transform: "rotate(-3deg) scale(1.02)",
                                zIndex: 5,
                            }}
                        />

                        <Image
                            src="/images/rolunk/LTGy-17.jpg"
                            alt="Laskodi Tészta"
                            position="absolute"
                            top={{ md: "370px", lg: "380px" }}
                            left={{ md: "150px", lg: "200px" }}
                            width={{ md: "260px", lg: "300px" }}
                            height={{ md: "350px", lg: "400px" }}
                            objectFit="cover"
                            border="10px solid white"
                            boxShadow="0 15px 35px rgba(0,0,0,0.16)"
                            transform="rotate(4deg)"
                            transition="all 0.3s ease"
                            _hover={{
                                transform: "rotate(2deg) scale(1.02)",
                                zIndex: 5,
                            }}
                        />

                    </Box>
                </Flex>
                <Flex
                    mt={{ base: 12, md: 20 }}
                    py={{ base: 8, md: 10 }}
                    px={{ base: 6, md: 10 }}
                    bg="red.50"
                    borderRadius="xl"
                    align="center"
                    justify="space-between"
                    direction={{ base: "column", md: "row" }}
                    gap={6}
                >

                    <Box
                        textAlign={{ base: "center", md: "left" }}
                    >
                        <Heading
                            fontFamily="'Playfair Display', serif"
                            fontSize={{ base: "2xl", md: "3xl" }}
                            color="gray.800"
                            mb={2}
                        >
                            Ismerje meg tésztáinkat!
                        </Heading>

                        <Text
                            fontFamily="Poppins, sans-serif"
                            color="gray.600"
                            fontSize={{ base: "sm", md: "md" }}
                            lineHeight="1.7"
                        >
                            Válogasson hagyományos, házias jellegű
                            Laskodi Száraztésztáink közül.
                        </Text>
                    </Box>

                    <Button
                        as={ReactLink}
                        to="/tesztaink"
                        colorScheme="red"
                        size="lg"
                        px={8}
                        fontFamily="Poppins, sans-serif"
                        fontWeight="600"
                        borderRadius="md"
                        _hover={{
                            bg: "red.600",
                            transform: "translateY(-2px)",
                            boxShadow: "md",
                        }}
                        transition="all 0.2s ease"
                    >
                        Tésztáink
                    </Button>

                </Flex>

            </Container>
        </Box>
    );
};

export default AboutUs;